
export class VMS_USER_MASTER  {
     USER_SEQ:any;
     USER_ID :any ;
     USER_NAME :any;
     NAME :any ;
     USER_PASSWORD:any;
     USER_CONFIRM_PASSWORD:any;
     USER_EMAIL :any;
     USER_LAST_LOGIN :any;
     USER_CREATED_ON :any; 
     USER_FORCE_PWD :any;
     USER_ROLE :any;
     USER_CREATED_BY :any='';
     USER_MODIFIED_BY :any='';
     USER_ACTIVE :any;
}
